import { render, staticRenderFns } from "./add-address.vue?vue&type=template&id=130be94c&scoped=true&"
import script from "./add-address.vue?vue&type=script&lang=js&"
export * from "./add-address.vue?vue&type=script&lang=js&"
import style0 from "./add-address.vue?vue&type=style&index=0&id=130be94c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130be94c",
  null
  
)

export default component.exports